export const DeploymentScriptSubItems = (t: (key: string) => string) => [
  {
    to: "/scripts",
    label: t("DeploymentScript"),
    roles: ["INFRA_ADMIN"],
  },
  {
    to: "/output-templates",
    label: t("OutputTemplate"),
  },
  {
    to: "/script-type",
    label: t("ScriptType"),
  }
];